
import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const windowsStore = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 1.69,
  type: 'WindowsStoreSpotLight',
  className: 'app-ad-windows',
  associationType: 'ImageSPOTLIGHT',
  stringKey: 'mageExperience_Image_Ratio_169x100',
  imagePreviewHeight: 182,
  imagePreviewWidth: 325,
  simplifiedType: 'ImageSPOTLIGHT',
  isRequired: true,
  minimumRequirements: 1,
  minSize: [1920, 1080],
  maxSize: [3840, 2160],
  localizedText: {
    previewTypeStringKey: _TL_('16:9 Microsoft Store spotlight ad'),
    stringKey: _TL_('16:9 Microsoft Store spotlight ad'),
  },
  previewSettings: {
    previewContentClassName: 'app-ad-169X100',
    showBusinessName: true,
    showBusinessNameFirst: true,
    showShortHeadline: true,
    hideLabel: true,
    showWinStore: true,
    showProng: false,
    showStart: false,
    showImage: true,
  },
  styleOverrides: {
    cardParent: {
      '& .responsive-ad-preview-content': {
        width: '418px !important',
        height: '300px !important',
        background: '#262632 !important',
      },
      '& .image-container': {
        position: 'absolute',
        height: 181,
        width: 325,
        top: 77,
        left: 70,
        borderRadius: 2.65,
        '& .cropped-image-view': {
          height: 181,
          width: 325,
          position: 'absolute',
          top: 0,
          borderRadius: 2.65,
          objectFit: 'cover',
        },
      },
      '& .text-container-apl': {
        position: 'absolute',
        top: 155,
        left: 94,
        '& .short-headline': {
          position: 'absolute',
          top: 15,
          fontSize: 7,
          fontWeight: 300,
          width: 200,
          color: 'white',
        },
        '& .business-name-with-ads': {
          position: 'absolute',
          top: 0,
          marginTop: 0,
          color: '#FFFFFF',
          fontWeight: 350,
          fontSize: 8,
        },
      },
    },
  },
};

export default windowsStore;

